module.exports = __webpack_public_path__ + "img/238.69c0c21.svg";